module.exports = __webpack_public_path__ + "static/media/7.99d6796b.jpg";